import { Injectable } from '@angular/core';
var MomentTimezone = require('moment-timezone');
const LOCAL_TIMEZONE = "America/Argentina/Buenos_Aires";
@Injectable()
export class FilterService {

  constructor() { }
  from:string
  to:string
  provider:any

  getDates(){
    let obj = JSON.parse(JSON.stringify({
        from:this.from,
        to:this.to,
        provider:this.provider,
    }));
      /*this.from=undefined
      this.to=undefined*/
      return obj
  }
  save(from,to,provider){
    this.from=from
    this.to=to
    this.provider=provider
  }

  getCurrentDate(){
    return MomentTimezone().tz(LOCAL_TIMEZONE).format('YYYY-MM-DDTHH:mm')
  }

  getDate(){
    return MomentTimezone().tz(LOCAL_TIMEZONE).format('YYYY-MM-DD');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/calls/filter.service.ts